import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class ChatStore {
    // textMessageInputValue: string = "";
    confirmationText: string = "";

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore
    }

    // setTextMessageInputValue = (msg: string) => {
    //     this.textMessageInputValue = msg;
    // }
    // get getTextMessageInputValue() {
    //     return this.textMessageInputValue;
    // }

    setconfirmationText = (Ctxt: string) => {
        this.confirmationText = Ctxt;
    }
    get getConfirmationText() {
        return this.confirmationText;
    }
}